// Builds a vCard 3.0 contact card (the .vcf format phones and address books import).

// vCard text values escape backslashes, commas, semicolons and newlines.
const esc = (value = '') => String(value).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');

export function buildVCard({ name, title, org, email, phone, url, city, country }) {
    const parts = name.trim().split(/\s+/);
    const family = parts.length > 1 ? parts[parts.length - 1] : '';
    const given = parts.length > 1 ? parts.slice(0, -1).join(' ') : parts[0];

    const lines = [
        'BEGIN:VCARD',
        'VERSION:3.0',
        `N:${esc(family)};${esc(given)};;;`,
        `FN:${esc(name)}`,
    ];
    if (org) lines.push(`ORG:${esc(org)}`);
    if (title) lines.push(`TITLE:${esc(title)}`);
    if (email) lines.push(`EMAIL;TYPE=INTERNET:${esc(email)}`);
    if (phone) lines.push(`TEL;TYPE=CELL:${phone.replace(/[^\d+]/g, '')}`);
    if (url) lines.push(`URL:${url}`);
    if (city || country) lines.push(`ADR;TYPE=WORK:;;;${esc(city)};;;${esc(country)}`);
    lines.push('END:VCARD');
    return `${lines.join('\r\n')}\r\n`;
}

// Triggers a download of the card in the browser (no server involved).
export function downloadVCard(card, filename = 'contact.vcf') {
    const blob = new Blob([card], { type: 'text/vcard;charset=utf-8' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(href), 1000);
}
